/**
 * Apply Form Module
 *
 * @file applyForm.js
 */
const applyForm = (() => {
  /**
   *
   * @param {string} name
   */
  // const getData = (name) => {
  //   const data = name;
  //   return data;
  // };

  const modalInputFile = () => {
    if(document.querySelector('.form-inp.upload input[type="file"]')){
      document.querySelector('.form-inp.upload input[type="file"]').addEventListener('change', function(e) {
        var fileName = e.target.files[0] ? e.target.files[0].name : "Görsellerinizi Yükleyin:";
        document.querySelector('.file-custom-text').textContent = fileName;
      });
    }
  }

  const accountFormButtonDisabled = () => {
    if(document.querySelectorAll('.ct-button')){
      document.querySelectorAll('.ct-button').forEach(function(button) {
        button.addEventListener('click', function() {
            var input = this.previousElementSibling; // Butonun hemen öncesindeki input elemanı
            var editText = this.getAttribute('data-edit-text');   // Düzenle metni
            var cancelText = this.getAttribute('data-cancel-text'); // Vazgeç metni
            
            if (input.disabled) {
                input.dataset.oldValue = input.value;  // Input'un eski değerini sakla
                input.value = '';  // Input'u boşalt
                input.disabled = false;  // Input etkin hale getiriliyor
                this.textContent = cancelText;  // Butonun yazısı 'Vazgeç' olarak değiştiriliyor
            } else {
                input.value = input.dataset.oldValue;  // Input'un eski değerini geri yükle
                input.disabled = true;  // Input tekrar devre dışı bırakılıyor
                this.textContent = editText;  // Butonun yazısı tekrar 'Düzenle' oluyor
            }
        });
      });
    }
  }

  /**
   * init module
   */
  const init = () => {
    // getData('data');
    modalInputFile();
    accountFormButtonDisabled();
  };

  return {
    init,
  };
})();

export default applyForm;
